export const selectLogsProducts = state => state.logs.logsProducts
export const selectLogsCompanies = state => state.logs.logsCompanies
export const selectCurrentCompany = state => state.logs.currentCompany
export const selectStateGenerated = state => state.logs.generated
export const selectLogsWareHouses = state => state.logs.logsWarehouses
export const selectLogsShopping = state => state.logs.logsShopping
